export const isTabDirty = (
  tabId: string,
  dirtyFields: Set<string>,
): boolean => {
  return !!Array.from(dirtyFields).filter((path) => {
    const regex = new RegExp(`^${tabId}.readings`, "i");
    return regex.test(path);
  }).length;
};
